import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register the service worker to enable offline support and PWA install prompt.
// To disable PWA behaviour, change .register() back to .unregister()
serviceWorkerRegistration.register({
  onSuccess: () => console.log('Family Calendar is ready for offline use.'),
  onUpdate: (registration) => {
    // Optionally notify the user a new version is available
    const waitingWorker = registration.waiting;
    if (waitingWorker) {
      waitingWorker.postMessage({ type: 'SKIP_WAITING' });
      window.location.reload();
    }
  },
});